import { Box } from "components/Box/Box";
import { CircularProgress } from '@chakra-ui/react'
import { theme } from 'theme';

export const Loader = () => (
    <Box position="fixed"
        top={0} bottom={0} left={0} right={0}
        display="flex" justifyContent="center" alignItems="center"
        height="100%">
        <CircularProgress isIndeterminate color={theme.colors.accent}/>
    </Box>
  
);